export default __webpack_public_path__ + "static/media/guidelines-3.a01a9887.jpeg";